import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

/**
 * Reusable collapsible section header for sidebar modules
 * Using shadcn/ui components with Tailwind
 */
function SectionHeader({ title, icon, isCollapsed, onToggle }) {
  return (
    <div 
      className={cn(
        "flex items-center justify-between px-3 py-2",
        "bg-muted/50 rounded-md cursor-pointer select-none",
        "hover:bg-muted transition-colors"
      )}
      onClick={onToggle} 
      role="button" 
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onToggle()}
    >
      <div className="flex items-center gap-2">
        {icon && <span className="text-lg">{icon}</span>}
        <span className="font-semibold text-sm">{title}</span>
      </div>
      <Button 
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        aria-label={isCollapsed ? "Expand" : "Collapse"}
      >
        {isCollapsed ? (
          <ChevronRight className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SectionHeader;
